import { Request } from '../utils';

export const createUser = async (newUser: Entities.BaseUser): Promise<void> => {
    await Request.post(`users/create`, newUser);
};

export const deleteUser = async ({ username }: Entities.BaseUser): Promise<void> => {
    await Request.post(`users/delete`, { username });
};

export const updateUser = async ({ username, role }: Entities.BaseUser): Promise<void> => {
    await Request.post(`users/update/${username}`, { username, role });
};

export const refreshTitles = async ({ username }: Entities.BaseUser): Promise<void> => {
    await Request.post(`users/refreshTitles`, { username });
};

export const updatePassword = async (password: string): Promise<void> => {
    await Request.post('users/me/password', { password });
};
